export default [
  {
    id: "shortest",
    label: "Trajet le plus rapide",
    color: "#ff4200",
    layers: [],
    loopQueryLayers: [],
    data: []
  },
  {
    id: "culture",
    label: "Promenade culturelle",
    color: "#ffb400",
    layers: [
      "culture-points",
      "culture-polygons",
      "culture-points-label",
      "culture-polygons-label"
    ],
    loopQueryLayers: [
      { name: "culture-points", type: "point" },
      { name: "culture-polygons", type: "polygon" }
    ],
    data: []
  },
  {
    id: "nightlife",
    label: "Sortie nocturne",
    color: "#9179ce",
    layers: [
      "nightlife-points",
      "nightlife-polygons",
      "nightlife-points-label",
      "nightlife-polygons-label"
    ],
    loopQueryLayers: [
      { name: "nightlife-points", type: "point" },
      { name: "nightlife-polygons", type: "polygon" }
    ],
    data: []
  },
  {
    id: "nature",
    label: "Envie de nature",
    color: "#46b946",
    layers: [],
    loopQueryLayers: [
      { name: "parks", type: "polygon" },
      { name: "water", type: "polygon" },
      { name: "waterway-river-canal", type: "line" }
    ],
    data: []
  },
  {
    id: "montpellier_noise_2017",
    label: "Promenade au calme",
    color: "#fcb4b4",
    layers: [],
    loopQueryLayers: [],
    data: []
  }
];



// WEBPACK FOOTER //
// ./src/config/theme.js